import { List, Map } from 'immutable'
import { FETCH_VIDEOS,
  SORT_CHANGED,
  PAGE_CHANGED,
  CLEAR_VIDEOS,
  SEARCH_CHANGED,
  EDIT_VIDEO,
  DELETE_VIDEO,
  MESSAGE,
  SHORTCODE_RECEIVED,
  FETCH_UPLOADS,
  UPLOAD_PROGRESS,
  UPLOAD,
  FETCH_VIDEO,
  RETRANSCODE,
  CREATE_VIDEO,
} from '../actions'

import { getVideo } from '../misc/selectors'

function setVideo(videoCache, video, newKey = 'shortcode', oldKey = 'shortcode') {
  if (!(video instanceof Map)) {
    video = new Map(video)
  }

  const existingVideo = videoCache.get(video.get(oldKey))
  if (existingVideo) {
    // don't update thumbnail
    const currentThumbnail = existingVideo.get('thumbnail_url')
    const newThumbnail = video.get('thumbnail_url')
    if (currentThumbnail && newThumbnail && currentThumbnail.split('?')[0] === newThumbnail.split('?')[0]) {
      video = video.delete('thumbnail_url')
    }
    
    return videoCache.delete(video.get(oldKey)).set(video.get(newKey), existingVideo.merge(video))
  }
  return replaceVideo(videoCache, video, newKey)
}

function setVideos(videoCache, videos, replace = false) {
  let output = videoCache
  for (const video of videos) {
    if (replace) {
      output = replaceVideo(output, video)
    } else {
      output = setVideo(output, video)
    }
  }
  return output
}

function replaceVideo(videoCache, video, key = 'shortcode') {
  if (!(video instanceof Map)) {
    video = Map(video)
  }
  return videoCache.set(video.get(key), video)
}

export default function videos(state = {
  isFetching: true,
  shortcodes: new List(),
  total: 0,
  sort: 'date_added',
  sortd: 'DESC',
  count: 16,
  page: 1,
  search: null,
  group_id: null,
  cache: new Map(),
  uploads: new List(),
  pending: new List(),
  loaded: false,
}, action) {
  switch (action.type) {
    case FETCH_UPLOADS:
      return { 
        ...state,
        cache: setVideos(state.cache, action.payload.map(item => new Map(item).delete('title').toObject())) 
      }
    case CREATE_VIDEO:
      if (action.payload.local_id) {
        return { ...state,
          total: state.total + 1,
          pending: state.pending.unshift(action.payload.local_id),
          cache: replaceVideo(state.cache,
            new Map(action.payload)
              .set('status', action.payload.status || 0)
              .set('date_added', Math.floor(Date.now() / 1000))
              .set('new_upload', true),
            'local_id'
            ),
        }
      } else {
        return { ...state,
          uploads: state.uploads.unshift(action.payload.shortcode),
          shortcodes: state.shortcodes.unshift(action.payload.shortcode),
          cache: setVideo(
            state.cache, 
            new Map(action.payload)
              .set('status', action.payload.status || 0)
              .set('new_upload', true)
          ),
        }
      }
    case SHORTCODE_RECEIVED:
      return { ...state,
        uploads: state.uploads.unshift(action.payload.shortcode),
        shortcodes: state.shortcodes.unshift(action.payload.shortcode),
        pending: state.pending.delete(state.pending.indexOf(action.payload.local_id)),
        cache: setVideo(state.cache, {
          ...new Map(action.payload.video).delete('title').toObject(),
          upload_metadata: action.payload,
          shortcode: action.payload.shortcode,
          local_id: action.payload.local_id,
        }, 'shortcode', 'local_id'),
      }
    case CLEAR_VIDEOS:
      return { ...state,
        shortcodes: state.shortcodes.clear(),
        loaded: false,
        total: 0,
        sort: 'date_added',
        sortd: 'DESC',
        count: 16,
        page: 1,
        search: null,
        group_id: null,
      }
    case FETCH_VIDEOS:
      if (action.error) {
        return {
          ...state,
          isFetching: false,
        }
      }
      if (action.payload.videos) {
        return { ...state,
          shortcodes: state.shortcodes.concat(action.payload.videos.map(v => v.shortcode)),
          total: action.payload.total,
          cache: setVideos(state.cache, action.payload.videos),
          loaded: true,
          isFetching: action.payload.isFetching,
        }
      }
      return { ...state, ...action.payload }
    case SORT_CHANGED:
      return { ...state,
        sort: action.payload,
      }
    case SEARCH_CHANGED:
      return { ...state,
        search: action.payload === '' ? null : action.payload,
      }
    case RETRANSCODE:
      return {
        ...state, cache: setVideo(state.cache, new Map(action.payload).set('files', null)),
      }
    case UPLOAD_PROGRESS:
    case FETCH_VIDEO:
    case UPLOAD:
      if (!action.error && action.payload.shortcode) {
        return {
          ...state, cache: setVideo(state.cache, action.payload),
        }
      }
      return state
    case EDIT_VIDEO:
      return { ...state,
        cache: action.payload.shortcode
          ? setVideo(state.cache, action.payload)
          : setVideo(state.cache, action.payload, 'local_id', 'local_id'),
      }
    case DELETE_VIDEO:
      let { uploads, pending, shortcodes } = state
      if (action.payload.local_id) {
        const uploadIdx = uploads.indexOf(action.payload.local_id);
        const pendingIdx = pending.indexOf(action.payload.local_id);
        uploads = uploadIdx >= 0 ? uploads.delete(uploadIdx) : uploads
        pending = pendingIdx >= 0 ? pending.delete(pendingIdx) : pending
      }
      if (action.payload.shortcode) {
        const uploadIdx = uploads.indexOf(action.payload.shortcode);
        const shortcodeIdx = shortcodes.indexOf(action.payload.shortcode);
        uploads = uploadIdx >= 0 ? uploads.delete(uploadIdx) : uploads
        shortcodes = shortcodeIdx >= 0 ? shortcodes.delete(shortcodeIdx) : shortcodes
      }
      return { ...state,
        pending,
        uploads,
        shortcodes,
      }
    case MESSAGE:
      if (action.payload.type === 'video') {
        // ignore title changes so we don't overwrite
        delete action.payload.payload.title
        //only do current version
        const video = getVideo(state.cache, action.payload.payload.shortcode)
        if (video.max_version == action.payload.payload.version) {
          return {
            ...state,
            cache: setVideo(state.cache, action.payload.payload),
          }
        }
      }

      return state
    default:
      return state
  }
}
